import React from 'react';
import { Box, Typography } from '@mui/material';

import {
  SectionContent,
  PageHeader,
  SEO,
  StyledList,
  AnimatedBlueBox,
  TwoColumnLayout,
  ContactLink
} from '../../components';
import ContactCTAButton from '../../components/common/buttons/ContactCTAButton';
import { ABOUT_US_CONTENT } from '../../data';
import { seoData } from '../../data/seoData';
import THEME from '../../constants/theme';
import { SUBSECTION_SPACING, ELEMENT_SPACING } from '../../constants';
import ROUTES from '../../config/routes';

const AboutUsPage = () => {
  const sections = ABOUT_US_CONTENT.SECTIONS;

  return (
    <>
      <SEO
        title={seoData.aboutUs.title}
        content={seoData.aboutUs.content}
        keywords={seoData.aboutUs.keywords}
        canonical={seoData.aboutUs.canonical}
        ogImage={seoData.aboutUs.ogImage}
      />

      <Box sx={{ backgroundColor: THEME.COLORS.NEUTRAL_WHITE }}>
        <PageHeader
          id='hero'
          title={ABOUT_US_CONTENT.TITLE}
          subtitle={ABOUT_US_CONTENT.SUBTITLE}
          path={ROUTES.ABOUT_US.ROOT}
        />
        <SectionContent
          id='mission'
          initialSpacing={false}
          text={[
            {
              text: sections.ABOUT.TEXT[0],
              fontSize: '1.3rem',
              marginBottom: ELEMENT_SPACING
            }
          ]}
        />
        <AnimatedBlueBox
          text={sections.ABOUT.TEXT[1]}
          marginTop={ELEMENT_SPACING}
          marginBottom={ELEMENT_SPACING}
        />
        <SectionContent
          initialSpacing={false}
          text={[
            {
              text: sections.ABOUT.TEXT[2],
              fontSize: '1.3rem',
              marginBottom: ELEMENT_SPACING
            }
          ]}
        />
        <TwoColumnLayout
          marginTop={SUBSECTION_SPACING}
          leftContent={
            <Box>
              <SectionContent
                title={sections.MISSION.TITLE}
                titleVariant='TitleMedium'
                titleMargin={`0 0 ${ELEMENT_SPACING} 0`}
                initialSpacing={false}
                text={[
                  {
                    text: sections.MISSION.TEXT[0],
                    fontSize: '1.3rem',
                    marginBottom: ELEMENT_SPACING
                  }
                ]}
              />
              <AnimatedBlueBox
                text={sections.MISSION.TEXT[1]}
                marginTop={ELEMENT_SPACING}
                marginBottom={ELEMENT_SPACING}
              />
              <SectionContent
                initialSpacing={false}
                text={[
                  {
                    text: sections.MISSION.TEXT[2],
                    fontSize: '1.3rem',
                    marginBottom: ELEMENT_SPACING
                  }
                ]}
              />
            </Box>
          }
          rightContent={
            <Box>
              <SectionContent
                id='leadership'
                title={sections.LEADERSHIP.TITLE}
                titleVariant='TitleMedium'
                titleMargin={`0 0 ${ELEMENT_SPACING} 0`}
                initialSpacing={false}
                text={[
                  {
                    text: sections.LEADERSHIP.TEXT[0],
                    fontSize: '1.3rem',
                    marginBottom: ELEMENT_SPACING
                  },
                  {
                    text: sections.LEADERSHIP.TEXT[1],
                    fontSize: '1.3rem',
                    marginBottom: ELEMENT_SPACING
                  },
                  {
                    text: sections.LEADERSHIP.TEXT[2],
                    marginBottom: ELEMENT_SPACING,
                    fontSize: '1.3rem'
                  }
                ]}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mt: SUBSECTION_SPACING
                }}
              >
                <ContactCTAButton>Schedule Your meeting</ContactCTAButton>
              </Box>
            </Box>
          }
        />
        <SectionContent
          id='principles'
          title={sections.PRINCIPLES.TITLE}
          titleVariant='TitleMedium'
          titleMargin={`${SUBSECTION_SPACING} 0 ${ELEMENT_SPACING} 0`}
          initialSpacing={true}
          text={[
            {
              text: sections.PRINCIPLES.INTRO,
              marginBottom: ELEMENT_SPACING,
              fontSize: '1.3rem'
            }
          ]}
        />
        <StyledList
          items={sections.PRINCIPLES.PRINCIPLES_LIST}
          titleTag='h3'
          titleVariant='h3'
        />
        {/* Learn more about CSR */}
        {/* <Box
          sx={{
            mt: SECTION_SPACING,
            mb: SECTION_SPACING
          }}
        >
          <Grid container justifyContent='center'>
            <Grid item xs={12} sm={6}>
              <InfoCard
                variant='elevated'
                title='Acting on Values, Not Visibility'
                description='Learn about our commitment to ethical business practices, sustainability initiatives, and how we give back to communities around the world.'
                imageSrc={csrImage}
                imageAlt='Acting on Values, Not Visibility'
                linkTo={ROUTES.ABOUT_US.CSR}
              />
            </Grid>
          </Grid>
        </Box> */}
        {/* Footer note with separator line */}
        <Box
          sx={{
            borderTop: `1px solid ${THEME.COLORS.NEUTRAL_GRAY}`,
            paddingTop: ELEMENT_SPACING,
            paddingBottom: ELEMENT_SPACING,
            mt: 4,
            mb: 2
          }}
        >
          <Typography
            variant='body2'
            sx={{
              fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.SECONDARY,
              fontSize: '1rem',
              fontStyle: 'italic',
              color: THEME.COLORS.PRIMARY_BLUE,
              lineHeight: 1.6,
              display: 'block'
            }}
          >
            Talk to an Expert –&nbsp;
            <ContactLink
              style={{
                color: THEME.COLORS.NEUTRAL_GRAY,
                textDecoration: 'underline',
                fontSize: '1rem'
              }}
            >
              Schedule Your meeting
            </ContactLink>
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default AboutUsPage;
